import React from 'react';
import { Outlet } from 'react-router-dom';
import AppShellLayout from '../shared/layout/app-shell-layout.jsx';
import { ComplianceModeProvider } from '../modules/system-navigation/context/compliance-mode-context.jsx';
import { HelpProvider } from '../context/help-context.jsx';
import { CallsProvider } from '../modules/calls/context/calls-context.jsx';
import CallsEditor from '../modules/calls/ui/calls-editor.jsx';
import CallsPanel from '../modules/calls/ui/calls-panel.jsx';

function AppShell() {
  return (
    <ComplianceModeProvider>
      <HelpProvider>
        <CallsProvider>
          <AppShellLayout>
            <Outlet />
          </AppShellLayout>
          <CallsPanel />
          <CallsEditor />
        </CallsProvider>
      </HelpProvider>
    </ComplianceModeProvider>
  );
}

export default AppShell;
